<div class="notifications-dropdown-container">
  <div class="notifications-header">
    <div class="notifications-header-content">
      <span>Notifications</span>
      <span class="counter" *ngIf="(notifications$ | async) && (notifications$ | async)?.items?.length">
        {{(notifications$ | async)?.count}}
      </span>
    </div>

    <button *ngIf="(notifications$ | async) && (notifications$ | async)?.items?.length"
            (click)="clearAll()"
            class="notifications-header-btn animation-focus-default"
    >
      Clear All
    </button>
  </div>

  <div *ngIf="(notifications$ | async) === undefined || (notifications$ | async)?.items?.length === 0" class="no-items">
    Looks like you’re all caught up!
  </div>

  <div *ngIf="(notifications$ | async) && (notifications$ | async)?.items?.length > 0" class="notifications-wrapper">
    <div *ngFor="let note of (notifications$ | async)?.items; let last = last"
         class="notification-item"
         [class.last]="last"
    >
      <div class="item-content">
        <div class="icon-type" [ngClass]="note.type">
          <img *ngIf="note.type === NotificationTypeEnum.FileSync"
               src="assets/icons/icon-alert-success-blue.svg"
               alt="note-icon"
          />
          <img *ngIf="note.type === NotificationTypeEnum.ConnectionError"
               src="assets/icons/icon-danger-red.svg"
               alt="note-success-icon"
          />
          <img *ngIf="note.type === NotificationTypeEnum.NewTeammate"
               src="assets/icons/icon-add-user.svg"
               alt="note-icon"
          />
          <img *ngIf="note.type === NotificationTypeEnum.OrderReceived"
               src="assets/icons/icon-download.svg"
               alt="note-icon"
          />
        </div>

        <div class="name-container">
          <div class="name">
            <span *ngIf="note.type === NotificationTypeEnum.FileSync">
              EDI file synced
            </span>
            <span *ngIf="note.type === NotificationTypeEnum.ConnectionError">
              EDI connection error
            </span>
            <span *ngIf="note.type === NotificationTypeEnum.OrderReceived">
              EDI order received
            </span>
            <span *ngIf="note.type === NotificationTypeEnum.NewTeammate">
              New teammate added
            </span>
          </div>
          <div class="description">
            <span *ngIf="note.type === NotificationTypeEnum.FileSync">
              EDI connection successful
            </span>
            <span *ngIf="note.type === NotificationTypeEnum.ConnectionError">
              EDI sync could not be established.
            </span>
            <span *ngIf="note.type === NotificationTypeEnum.OrderReceived">
              EDI was successfully received at {{note.createDate | date: 'h:mm a'}}.
            </span>
            <span *ngIf="note.type === NotificationTypeEnum.NewTeammate">
              {{note.userName || 'User'}} was added to your team
            </span>
            <span>
            <a *ngIf="note.type === NotificationTypeEnum.ConnectionError"
               routerLink="edi-connection"
               class="ref"
               (click)="linkSelected.emit()"
            >
              Resolve now
            </a>
            <a *ngIf="note.type === NotificationTypeEnum.OrderReceived"
               routerLink="inventory/order-history"
               class="ref"
               (click)="linkSelected.emit()"
            >
              View order
            </a>
          </span>
          </div>
        </div>
      </div>
      <div class="item-time-ago">
        {{note.createDate | timeAgo}}
      </div>
    </div>
  </div>

  <div *ngIf="(notifications$ | async)?.count > (notifications$ | async)?.items?.length"
       class="notifications-control"
  >
    <button type="button" class="table-payload-btn animation-focus-default" (click)="loadMore()">
      Load More
    </button>
  </div>
</div>
